import { Card, CardContent, CardHeader } from '@/common/components/Card.tsx'
import {
  FormRowLabel,
  FormRowLayout,
  FormRowValue,
} from '@/common/components/FormRow/FormRow.tsx'
import { Disclosure, DisclosureButton } from '@headlessui/react'
import {
  FamilyApplicationDetails,
  Student,
} from '@/queries/family_applications/requests.ts'
import { MinusIcon, PlusIcon } from '@/common/icons/arrows.tsx'
import Image from '@/common/components/Image.tsx'
import React from 'react'
import { useApplicationDocumentLogging } from '@/pages/applicants/applicant_details/hooks/useApplicationDocumentLogging.ts'

interface Props {
  application?: FamilyApplicationDetails | null
  selectedStudent?: Student | null
  status?: string | null
}

const StudentDetails: React.FC<Props> = ({ selectedStudent, application }) => {
  const logView = useApplicationDocumentLogging({
    logType: 'student',
    applicantId: application?.user_id ?? null,
    studentId: selectedStudent?.id ?? 0,
  })

  const getLeaParticipation = (value: number) => {
    switch (value) {
      case 1:
        return 'Yes'
      case 2:
        return 'No'
      default:
        return 'Not Sure'
    }
  }

  const globalProgramScholarships = [
    {
      id: 3,
      name: 'Carson Smith Scholarship Program',
    },
    {
      id: 4,
      name: 'Special Needs Opportunity Scholarship Program',
    },
  ]

  return (
    <Card>
      <CardHeader>Students Details</CardHeader>
      <CardContent>
        <FormRowLayout>
          <FormRowLabel>Name</FormRowLabel>
          <FormRowValue>{selectedStudent?.name}</FormRowValue>
        </FormRowLayout>
        <FormRowLayout>
          <FormRowLabel>Status</FormRowLabel>
          <FormRowValue>{selectedStudent?.status}</FormRowValue>
        </FormRowLayout>
        {application?.status == 'Ineligible' && (
          <FormRowLayout>
            <FormRowLabel>{application?.status}</FormRowLabel>
            <FormRowValue>
              {selectedStudent?.withdrawn_by
                ? `Withdrawn by ${selectedStudent?.withdrawn_by}`
                : ''}
            </FormRowValue>
          </FormRowLayout>
        )}
        <FormRowLayout>
          <FormRowLabel>Grade Level</FormRowLabel>
          <FormRowValue>{selectedStudent?.grade}</FormRowValue>
        </FormRowLayout>
        <FormRowLayout>
          <FormRowLabel>Enrolled in LEA</FormRowLabel>
          <FormRowValue>
            {getLeaParticipation(Number(selectedStudent?.lea_participation))}
          </FormRowValue>
        </FormRowLayout>
        <FormRowLayout>
          <FormRowLabel>Competing Scholarships</FormRowLabel>
          <FormRowValue>
            {selectedStudent?.competing_scholarship_ids?.map((id: number) => (
              <div className="text-right">
                {
                  globalProgramScholarships.find(
                    (scholarship) => scholarship.id == id
                  )?.name
                }
              </div>
            ))}
          </FormRowValue>
        </FormRowLayout>

        <FormRowLayout className="flex-col items-start">
          <Disclosure>
            {({ open }) => {
              if (open && selectedStudent?.birth_certificate_path) {
                logView()
              }
              return (
                <>
                  <div className="flex flex-row w-full items-center justify-between">
                    <FormRowLabel>
                      Birth Certificate/Age & Relationship Documents
                    </FormRowLabel>
                    <DisclosureButton className="flex items-center">
                      <span className="text-sm text-gray-400">
                        {open ? <MinusIcon /> : <PlusIcon />}
                      </span>
                    </DisclosureButton>
                  </div>
                  {open && (
                    <FormRowValue>
                      {selectedStudent?.birth_certificate_path && (
                        <Image
                          key={selectedStudent?.birth_certificate_path}
                          allowZoom={true}
                          path={selectedStudent?.birth_certificate_path ?? ''}
                        />
                      )}
                    </FormRowValue>
                  )}
                </>
              )
            }}
          </Disclosure>
        </FormRowLayout>
      </CardContent>
    </Card>
  )
}
export default StudentDetails
